import { InstanceScreen } from 'component/navigation/instance';

export default function AdminIndexScreen() {
    return <InstanceScreen />;
}
